module.exports = __webpack_public_path__ + "media/images/countrysquared/ws-d6dc5fa7390e1bf744891d0b230ea5b7.svg";